<template>
  <div class="rj-page-card">
    <div class="rj-page-card__content">
      <el-tabs v-model="listType" @tab-click="onTabChange">
        <el-tab-pane label="我的退款" name="MY" />
        <el-tab-pane name="TODO">
          <span slot="label">
            待办
            <el-badge v-if="todoCount > 0" :value="todoCount" style="margin-left: 4px;" />
          </span>
        </el-tab-pane>
        <el-tab-pane label="已办" name="DONE" />
      </el-tabs>

      <el-form ref="searchForm" :inline="true" class="searchBoxLine" :model="searchForm">
        <el-form-item label="退款申请单号:" prop="refundNum">
          <el-input
            v-model.trim="searchForm.refundNum"
            placeholder="请输入退款申请单号"
            clearable
            @keyup.enter.native="doSearch"
          />
        </el-form-item>
        <el-form-item label="业务实体:" prop="businessEntity">
          <el-input
            v-model.trim="searchForm.businessEntity"
            placeholder="请输入业务实体"
            clearable
            @keyup.enter.native="doSearch"
          />
        </el-form-item>
        <el-form-item label="收款编号:" prop="telegraphicTransferNum">
          <el-input
            v-model.trim="searchForm.telegraphicTransferNum"
            placeholder="请输入收款编号"
            clearable
            @keyup.enter.native="doSearch"
          />
        </el-form-item>
        <el-form-item label="当前状态:" prop="state">
          <el-select v-model="searchForm.state" placeholder="请选择" clearable>
            <el-option label="审批中" value="审批中" />
            <el-option label="驳回待提交" value="驳回待提交" />
            <el-option label="已完成" value="已完成" />
            <el-option label="已废弃" value="已废弃" />
          </el-select>
        </el-form-item>
        <el-form-item label="申请日期:" prop="createBeginTime">
          <div class="rj-flex">
            <div class="rj-flex__item">
              <el-date-picker
                v-model="searchForm.createBeginTime"
                type="date"
                value-format="yyyy-MM-dd"
                placeholder="选择日期"
                clearable
                style="width: 150px;"
                :picker-options="beginDatePickerOptions"
              />
            </div>
            <div style="display: inline-block;width: 10px;text-align: center">-</div>
            <div class="rj-flex__item">
              <el-date-picker
                v-model="searchForm.createEndTime"
                type="date"
                value-format="yyyy-MM-dd"
                placeholder="选择日期"
                clearable
                style="width: 150px;"
                :picker-options="endDatePickerOptions"
              />
            </div>
          </div>
        </el-form-item>
        <el-button type="primary" :loading="isLoading" @click="doSearch">
          查询
        </el-button>
        <el-button type="default" @click="resetForm">
          重置
        </el-button>
      </el-form>

      <el-table v-loading="isLoading" :data="tableData" border style="width: 100%">
        <el-table-column type="index" width="60" label="序号" align="left" fixed="left" />
        <el-table-column prop="refundNum" label="退款申请单号" align="left" min-width="140" />
        <el-table-column prop="businessEntity" label="业务实体" align="left" min-width="120" />
        <el-table-column prop="telegraphicTransferNum" label="收款编号" align="left" min-width="130" />
        <el-table-column prop="returnAmount" label="退款金额" align="right" header-align="left" min-width="100" />
        <el-table-column prop="currency" label="币种" align="left" width="70" />
        <el-table-column prop="returnAmountUsd" label="折算USD" align="right" header-align="left" min-width="100" />
        <el-table-column prop="applicationName" label="申请人" align="left" width="100" />
        <el-table-column prop="applicationTime" label="申请日期" align="left" min-width="140" />
        <el-table-column prop="stateAndApprover" label="当前状态" align="left" min-width="140" />
        <el-table-column label="操作" width="160" align="left" fixed="right">
          <template v-slot="{row}">
            <el-button type="text" @click="lookDetail(row)">
              查看
            </el-button>
            <!-- 办理仅待办；已办只读历史，不展示办理/编辑等 -->
            <el-button v-if="listType === 'TODO' && row.isConduct" type="text" @click="handelFn(row)">
              办理
            </el-button>
            <el-button v-if="listType === 'MY' && row.canEdit" type="text" @click="editFn(row)">
              编辑
            </el-button>
            <el-button v-if="listType === 'MY' && row.canRecall" type="text" @click="recallFn(row)">
              召回
            </el-button>
            <el-button v-if="listType === 'MY' && row.canAbandon" type="text" @click="abandonFn(row)">
              废弃
            </el-button>
          </template>
        </el-table-column>
      </el-table>

      <div style="text-align: right;margin-top: 10px">
        <el-pagination
          :page-sizes="[10, 20, 30, 40]"
          :page-size.sync="page.pageSize"
          :current-page.sync="page.currentPage"
          layout="total, prev, pager, next, jumper,sizes"
          :total="page.total"
          hide-on-single-page
          @size-change="handerSizeChange"
          @current-change="handerCurrentChange"
        />
      </div>
    </div>

    <overseas-refund-detail-dialog ref="detailDialog" />
    <overseas-refund-transact-dialog ref="transactDialog" @on-ok="doSearch" />
    <overseas-refund-recall-dialog ref="recallDialog" @on-ok="doSearch" />
    <overseas-refund-edit-dialog ref="editDialog" @on-ok="doSearch" />
  </div>
</template>

<script>
import { overseasRefundAbandon, overseasRefundSelectList } from '@/API';
import OverseasRefundDetailDialog from './DetailDialog.vue';
import OverseasRefundTransactDialog from './TransactDialog.vue';
import OverseasRefundRecallDialog from './RecallDialog.vue';
import OverseasRefundEditDialog from './EditDialog.vue';

export default {
  name: 'OverseasRefundList',
  components: {
    OverseasRefundDetailDialog,
    OverseasRefundTransactDialog,
    OverseasRefundRecallDialog,
    OverseasRefundEditDialog
  },
  data () {
    const routeId = this.$route.query.id;
    let focusRefundId;
    if (routeId !== undefined && routeId !== null && routeId !== '') {
      const num = Number(routeId);
      if (Number.isFinite(num)) {
        focusRefundId = num;
      }
    }
    return {
      listType: this.resolveListType() || 'MY',
      /** 邮件跳转定位的主单 id（仅首次从 URL 带入；切 Tab/重置后清除） */
      focusRefundId,
      isLoading: false,
      tableData: [],
      todoCount: 0,
      searchForm: {
        refundNum: '',
        businessEntity: '',
        telegraphicTransferNum: '',
        state: '',
        createBeginTime: '',
        createEndTime: ''
      },
      page: {
        currentPage: 1,
        pageSize: 10,
        total: 0
      },
      beginDatePickerOptions: {
        disabledDate: (time) => {
          if (!this.searchForm.createEndTime) {
            return false;
          }
          return time.getTime() > new Date(this.searchForm.createEndTime).getTime();
        }
      },
      endDatePickerOptions: {
        disabledDate: (time) => {
          if (!this.searchForm.createBeginTime) {
            return false;
          }
          const begin = new Date(this.searchForm.createBeginTime);
          begin.setHours(0, 0, 0, 0);
          return time.getTime() < begin.getTime();
        }
      }
    };
  },
  watch: {
    '$route.query.listType' (val) {
      // 左侧菜单再次进入会清掉 query，按待办数重新选默认 Tab
      if (val === 'TODO' || val === 'DONE' || val === 'MY') {
        return;
      }
      this.applyMenuDefaultTab().then(() => this.doSearch());
    }
  },
  mounted () {
    this.applyMenuDefaultTab().then(() => {
      this.doSearch().then(() => {
        this.openFromUrl();
      });
    });
  },
  methods: {
    onTabChange () {
      this.page.currentPage = 1;
      this.focusRefundId = undefined;
      // 一次 replace：切 Tab 并去掉邮件定位 id，避免二次 replace 把旧 id 带回来
      const query = { ...this.$route.query, listType: this.listType };
      delete query.id;
      this.$router.replace({ query });
      this.doSearch();
    },
    resolveListType () {
      const type = this.$route.query.listType;
      if (type === 'TODO' || type === 'DONE' || type === 'MY') {
        return type;
      }
      return '';
    },
    /**
     * 菜单进入（URL 无 listType）：待办数 > 0 则默认待办，否则我的退款。
     * 邮件/Tab 已带 listType 时尊重 URL，不覆盖。
     */
    applyMenuDefaultTab () {
      const type = this.$route.query.listType;
      if (type === 'TODO' || type === 'DONE' || type === 'MY') {
        this.listType = type;
        this.loadTabCounts();
        return Promise.resolve();
      }
      return this.loadTabCounts().then(() => {
        this.listType = this.todoCount > 0 ? 'TODO' : 'MY';
        const query = { ...this.$route.query, listType: this.listType };
        return this.$router.replace({ query }).catch(() => {});
      });
    },
    clearFocusRefundId () {
      this.focusRefundId = undefined;
      if (!this.$route.query.id) {
        return;
      }
      const query = { ...this.$route.query };
      delete query.id;
      this.$router.replace({ query });
    },
    syncListTypeToUrl () {
      const query = { ...this.$route.query, listType: this.listType };
      // 同步 listType 时也不要保留邮件定位 id
      delete query.id;
      this.focusRefundId = undefined;
      this.$router.replace({ query });
    },
    buildParams () {
      return {
        listType: this.listType,
        pageIndex: this.page.currentPage,
        pageSize: this.page.pageSize,
        overseasRefundId: this.focusRefundId,
        refundNum: this.searchForm.refundNum || undefined,
        businessEntity: this.searchForm.businessEntity || undefined,
        telegraphicTransferNum: this.searchForm.telegraphicTransferNum || undefined,
        state: this.searchForm.state || undefined,
        createBeginTime: this.searchForm.createBeginTime || undefined,
        createEndTime: this.searchForm.createEndTime || undefined
      };
    },
    doSearch () {
      const begin = this.searchForm.createBeginTime;
      const end = this.searchForm.createEndTime;
      if (begin && end && begin > end) {
        this.$message.warning('申请开始日期不能大于结束日期');
        return Promise.resolve();
      }
      this.isLoading = true;
      return overseasRefundSelectList(this.buildParams())
        .then(res => {
          // axios 返回完整 response：RemoteResult 在 res.data，PageInfo 在 res.data.data
          const pageInfo = (res && res.data && res.data.data) || {};
          this.tableData = pageInfo.list || [];
          this.page.total = pageInfo.total || 0;
          this.updateCurrentTabCount(pageInfo.total || 0);
        })
        .finally(() => {
          this.isLoading = false;
        });
    },
    loadTabCounts () {
      return overseasRefundSelectList({ listType: 'TODO', pageIndex: 1, pageSize: 1 })
        .then(res => {
          const pageInfo = (res && res.data && res.data.data) || {};
          this.todoCount = pageInfo.total || 0;
          return this.todoCount;
        })
        .catch(() => {
          this.todoCount = 0;
          return 0;
        });
    },
    updateCurrentTabCount (count) {
      if (this.listType === 'TODO') {
        this.todoCount = count;
      }
    },
    resetForm () {
      this.searchForm = {
        refundNum: '',
        businessEntity: '',
        telegraphicTransferNum: '',
        state: '',
        createBeginTime: '',
        createEndTime: ''
      };
      this.page.currentPage = 1;
      this.clearFocusRefundId();
      this.doSearch();
    },
    lookDetail (row) {
      if (this.listType === 'DONE' && row.snapshotId) {
        this.$refs.detailDialog && this.$refs.detailDialog.openSnapshot(row.snapshotId);
        return;
      }
      this.$refs.detailDialog && this.$refs.detailDialog.open(row.overseasRefundId);
    },
    handelFn (row) {
      this.$refs.transactDialog && this.$refs.transactDialog.open(row.overseasRefundId, row.currentTodoNodeId);
    },
    /**
     * 邮件跳转：TODO+id → 办理弹窗；MY+id → 定位列表并打开详情。
     */
    openFromUrl () {
      const detailId = this.focusRefundId;
      if (!detailId) {
        return;
      }
      this.$nextTick(() => {
        if (this.listType === 'TODO') {
          this.$refs.transactDialog && this.$refs.transactDialog.open(detailId);
          return;
        }
        if (this.listType === 'DONE') {
          // 邮件跳到 MY；DONE 需 snapshotId，URL 仅带主单 id 时用实时详情兜底
          this.$refs.detailDialog && this.$refs.detailDialog.open(detailId);
          return;
        }
        this.$refs.detailDialog && this.$refs.detailDialog.open(detailId);
      });
    },
    editFn (row) {
      this.$refs.editDialog && this.$refs.editDialog.open(row.overseasRefundId);
    },
    recallFn (row) {
      this.$refs.recallDialog && this.$refs.recallDialog.open(row.overseasRefundId);
    },
    abandonFn (row) {
      this.$confirm('确认废弃该国际退款单？废弃后不可恢复。', '提示', { type: 'warning' })
        .then(() => overseasRefundAbandon({ overseasRefundId: row.overseasRefundId }))
        .then((res) => {
          // axios 拦截器业务失败仍会 resolve 并弹出错误；此处必须判 status
          const status = res && res.data && res.data.status;
          if (status === '200') {
            this.$message.success('废弃成功');
            this.doSearch();
          }
        })
        .catch(() => {});
    },
    handerSizeChange (size) {
      this.page.pageSize = size;
      this.page.currentPage = 1;
      this.doSearch();
    },
    handerCurrentChange (page) {
      this.page.currentPage = page;
      this.doSearch();
    }
  }
};
</script>
